import template from './progress-spinner.html';
export var ProgressSpinnerComponent = {
    template: template,
    bindings: {
        message: '@',
        hideMessage: '<'
    }
};
//# sourceMappingURL=progress-spinner.component.js.map